import React, { useState } from 'react';
import {
  Button,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@ais-ui/ui-core';
import { PiDotsThreeVertical } from 'react-icons/pi';
import type { LayerItem } from '@ais-ui/react-openlayers';
import { TrackTimeControl } from './NestedLayerRow/TrackTimeControl';
import { VectorTrackDisplayToggles } from './VectorTrackDisplayToggles';
import { VectorTrackColorControl } from './VectorTrackColorControl';

interface VectorTrackActionsProps {
  layer: LayerItem;
}

export const VectorTrackActions = React.memo(
  ({ layer }: VectorTrackActionsProps) => {
    const [open, setOpen] = useState(false);

    return (
      <Popover open={open} onOpenChange={setOpen}>
        <Tooltip>
          <TooltipTrigger asChild>
            <PopoverTrigger asChild>
              <Button
                size="icon"
                variant="ghost"
                className="h-9 w-9 flex-shrink-0 p-0 m-0"
                onClick={(e) => e.stopPropagation()}
              >
                <PiDotsThreeVertical className="size-5" />
              </Button>
            </PopoverTrigger>
          </TooltipTrigger>
          <TooltipContent>Track options</TooltipContent>
        </Tooltip>
        <PopoverContent
          className="w-auto p-2"
          align="end"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex items-center gap-1">
            <TrackTimeControl
              layerId={layer.id}
              currentHours={layer.properties.trackHours}
            />
            <VectorTrackDisplayToggles layer={layer} />
            <VectorTrackColorControl layer={layer} />
          </div>
        </PopoverContent>
      </Popover>
    );
  },
);

VectorTrackActions.displayName = 'VectorTrackActions';
